import { ComponentFactory, ComponentFactoryResolver, Injectable, Type } from '@angular/core';
import { NotificationType, NotificationTypes } from './domains';
import { NotificationBase } from './interfaces/notification-base.interface';

@Injectable({
  providedIn: 'root'
})
export class NotificationFactory {
  notificationTypes = NotificationTypes;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
  }

  create(notification: NotificationBase): ComponentFactory<NotificationBase> {
    const notificationType: Type<NotificationType> = this.notificationTypes[
      notification.domain
    ];

    const notificationFactory = this.componentFactoryResolver.resolveComponentFactory(
      notificationType
    );
    return (notificationFactory as ComponentFactory<NotificationBase>);
  };
}
